import { GraduationCap } from "lucide-react";
import { toast } from "sonner";
import { api, money, formatApiError } from "../lib/api";

export const SchoolLine = ({ tier, m, charities, onDone }) => {
  const change = async (e) => {
    try { await api.put(`/memberships/${tier}/school`, { school_id: e.target.value }); toast.success("School updated"); onDone(); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <div className="mt-4 text-xs text-slate-400 flex flex-wrap items-center gap-2" data-testid="member-school">
      <GraduationCap className="w-4 h-4 text-[#38BDF8]" />Supporting
      <select data-testid="member-school-select" value={m.school_id || ""} onChange={change} className="bg-transparent border border-white/10 rounded-full px-3 py-1 text-slate-200">
        {!m.school_id && <option value="">Pick a trade school</option>}
        {charities.map((c) => <option key={c.id} value={c.id} className="bg-[#13192B]">{c.name}</option>)}
      </select>
      {m.scholarship_addon > 0 && <span data-testid="member-addon" className="text-emerald-300">+{money(m.scholarship_addon)}/mo scholarship gift</span>}
    </div>
  );
};
